// © Microsoft Corporation. All rights reserved.

import { CommunitySettings } from "@msnews/pdp-service-library";

export function isUserOptedOutOfComments(userCommunitySettings: CommunitySettings) {
    if (userCommunitySettings && userCommunitySettings.commentsOptOut === "1") {
        return true;
    }
    return false;
}

export function isUserOptedOutOfReactions(userCommunitySettings: CommunitySettings) {
    if (userCommunitySettings && userCommunitySettings.reactionsOptOut === "1") {
        return true;
    }
    return false;
}